<template>
  <div>
    <div class="succeed-main">
      <!-- 成功案例切换按钮 -->
      <div class="succeed-span">
        <div
          class="succeed-span"
          v-for="(item, index) in succeedList"
          :key="index"
          :class="{ Succeedactive: SucceedIndex === index }"
          @click="changeSucceed(index)"
        >
          <span class="succees-span-item wow animate__zoomIn">{{ item.title }}</span>
        </div>
      </div>
      <!-- 成功案例整体 -->
      <div class="succeed-example">
        <div class="succeed-example-main">
          <!-- 水井坊 -->
          <div v-if="SucceedIndex === 0"  class="succeed-example-make">
            <div
              class="succeed-example-left"
              :class="SucceedIndex === index ? 'wow animate__fadeInLeft' : ' '"
            >
              <div class="example-make">{{ succeedList[0].message }}</div>
              <div class="example-introduce">
                {{ succeedList[0].introduction }}
              </div>
            </div>
            <div
              class="succeed-example-right"
              :class="SucceedIndex === index ? 'wow animate__fadeInRight' : ' '"
            >
              <div class="example-img">
                <img
                  :src="succeedList[0].coverImage"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 北京体育大学 -->
          <div v-else-if="SucceedIndex === 1" class="succeed-example-make">
            <div
              class="succeed-sports"
              :class="SucceedIndex === index ? 'wow animate__fadeInRight' : ' '"
            >
              <div class="sports-img">
                <img
                  :src="succeedList[1].coverImage"
                  alt=""
                />
              </div>
            </div>
            <div
              class="succeed-example-sports"
              :class="SucceedIndex === index ? 'wow animate__fadeInLeft' : ' '"
            >
              <div class="example-make-sports">{{ succeedList[1].message }}</div>
              <div class="example-introduce-sports">
                {{ succeedList[1].introduction }}
              </div>
            </div>
          </div>
          <!-- 陈露冰场 -->
          <div v-else class="succeed-example-make">
            <div
              class="succeed-example-rink"
              :class="SucceedIndex === index ? 'wow animate__fadeInLeft' : ' '"
            >
              <div class="example-make-rink">{{ succeedList[2].message }}</div>
              <div class="example-introduce-rink">
                {{ succeedList[2].introduction }}
              </div>
            </div>
            <div
              class="succeed-sports"
              :class="SucceedIndex === index ? 'wow animate__fadeInRight' : ' '"
            >
              <div class="rink-img">
                <img
                  :src="succeedList[2].coverImage"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import newsOne from "../../../../assets/newsone.png";
import succeedTwo from "../../../../assets/succedTwo.png";
import succeedThree from "../../../../assets/succedThree.png";
export default {
  data() {
    return {
      SucceedIndex: 0, //成功案例选中的tab
      index:0,
      //成功案例
      succeedList: [
        {
          title: "水井坊最强乒团·2022中国业余乒乓球团体赛远程制作", //标题
          message: "“水井坊”最强乒团·2022中国业余乒乓球团体赛远程制作",
          introduction:
            "奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署，依托奇点智播赛事制作中心强大的资源支撑，为“最强乒团”提供高质量的赛事转播服务。“远程制作”解决方案是在赛事现场部署多讯道摄像机及拾音系统完成采集，通过多种网络线路将视音频信号以极低时延和多机位同步方式回传至奇点智播北京制作中心。北京制作中心在制作间进行切换、图文、实时慢动作、混音等制作后，将最终的PGM信号进行多平台分发。", //简介
          coverImage: newsOne //封面图
        },
        {
          title: "北京体育大学演播助训小程序", //标题
          message: "北京体育大学演播助训小程序",
          introduction:
            "北京体育大学演播助训小程序是由北京奇点智播科技有限公司研发的一款面向专业运动训练与教学场景，为教练员和运动员提供观看训练视频的微信小程序。小程序配备云端业务定制化开发、系统管理平台开发，采用多机位同步技术、HLS切片技术，可以实现小程序的多视角直播、多视角点播、视频自动剪辑与混剪、实时打点等功能。奇点智播研发的小程序旨在提升教学效率与训练效果，目前已在国家蹦床训练队、国家跆拳道队展开应用。", //简介
          coverImage: succeedTwo //封面图
        },
        {
          title: "陈露国际冰场【智慧冰场】服务", //标题
          message: "陈露国际冰场【智慧冰场】服务",
          introduction:
            "奇点智播【智慧冰场】服务方案在冰场建立多角度多区域的视频数据采集摄像头，在平时教学训练过程中，采集收录学员的花样滑冰动作，之后通过AI算法对动作进行训练识别，同时研发“i滑”APP客户端，最终APP可以呈现自动识别和输出的小学员个人精彩训练短视频。", //简介
          coverImage: succeedThree //封面图
        }
      ]
    };
  },
  methods: {
    //成功案例
    changeSucceed(index) {
      this.SucceedIndex = index;
    }
  }
};
</script >
<style lang="less" scoped>
@import "./succeed-case.less";
</style>



// WEBPACK FOOTER //
// src/views/home/components/succeed-case/succeed-case.vue